var _excluded = ["listingType", "showRecent"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { ListingType } from '@domain-group/fe-allhomes-library';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import AutocompleteType from '../utils/autocomplete-types';
import AllhomesAutocomplete from '../allhomes-autocomplete';
import { jsx as ___EmotionJSX } from "@emotion/core";
var RECENT_SEARCH_KEY = 'recent-searches';
var ADDRESS = AutocompleteType.ADDRESS,
  STREET = AutocompleteType.STREET,
  DIVISION = AutocompleteType.DIVISION,
  POSTCODE = AutocompleteType.POSTCODE,
  DISTRICT = AutocompleteType.DISTRICT,
  REGION = AutocompleteType.REGION,
  DEVELOPMENT = AutocompleteType.DEVELOPMENT,
  SCHOOL = AutocompleteType.SCHOOL;
var names = function names() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return list.map(_ref => {
    var name = _ref.name;
    return name;
  });
};
var immediateTypes = names([ADDRESS, SCHOOL, DEVELOPMENT]);
var ALL_TYPES = names([ADDRESS, POSTCODE, REGION, DISTRICT, DIVISION, SCHOOL, DEVELOPMENT, STREET]);
var RESI_TYPES = names([ADDRESS, POSTCODE, REGION, DISTRICT, DIVISION, SCHOOL, STREET]);
var COMMERCIAL_TYPES = names([ADDRESS, POSTCODE, REGION, DISTRICT, DIVISION, STREET]);
var ALL_PLACEHOLDER = 'Type a location, school name, project name or address';
var DEV_PLACEHOLDER = 'Type a location, project name or school';
var RESI_PLACEHOLDER = 'Type a location, school name or address';
var ALL_MOBILE_PLACEHOLDER = RESI_PLACEHOLDER;
var DEFAULT_PLACEHOLDER = 'Type a location, postcode or address';
var TypeMap = {
  [ListingType.SALES_RESIDENTIAL.name]: {
    types: ALL_TYPES,
    placeholder: ALL_PLACEHOLDER,
    mobilePlaceholder: ALL_MOBILE_PLACEHOLDER
  },
  [ListingType.RENTAL_RESIDENTIAL.name]: {
    types: RESI_TYPES,
    placeholder: RESI_PLACEHOLDER
  },
  [ListingType.SHARE_RESIDENTIAL.name]: {
    types: RESI_TYPES,
    placeholder: RESI_PLACEHOLDER
  },
  [ListingType.DEVELOPMENTS_RESIDENTIAL.name]: {
    types: ALL_TYPES,
    placeholder: DEV_PLACEHOLDER
  },
  [ListingType.SALES_COMMERCIAL.name]: {
    types: COMMERCIAL_TYPES
  },
  [ListingType.SALES_BUSINESS.name]: {
    types: COMMERCIAL_TYPES
  },
  [ListingType.RENTAL_COMMERCIAL.name]: {
    types: COMMERCIAL_TYPES
  }
};
var ListingSearchAutocomplete = _ref2 => {
  var listingType = _ref2.listingType,
    showRecent = _ref2.showRecent,
    props = _objectWithoutProperties(_ref2, _excluded);
  var typeProps = _objectSpread({
    immediateTypes,
    placeholder: DEFAULT_PLACEHOLDER
  }, TypeMap[listingType] || TypeMap[ListingType.SALES_RESIDENTIAL.name]);
  return ___EmotionJSX(EventBoundary, {
    data: {
      listingType
    }
  }, ___EmotionJSX(AllhomesAutocomplete, _extends({}, typeProps, {
    recentSearchKey: showRecent ? RECENT_SEARCH_KEY : undefined,
    saveRecentOnSearch: showRecent
  }, props)));
};
ListingSearchAutocomplete.immediateTypes = immediateTypes;
ListingSearchAutocomplete.propTypes = {
  listingType: PropTypes.string,
  showRecent: PropTypes.bool,
  onSearch: PropTypes.func,
  onImmediateSearch: PropTypes.func,
  onRecentSearch: PropTypes.func,
  onSelectionChange: PropTypes.func,
  onDropdownOpen: PropTypes.func,
  allowDefaultSearch: PropTypes.bool
};
ListingSearchAutocomplete.defaultProps = {
  listingType: ListingType.SALES_RESIDENTIAL.name,
  showRecent: false,
  onSearch: () => {},
  onImmediateSearch: undefined,
  onRecentSearch: undefined,
  onSelectionChange: () => {},
  onDropdownOpen: () => {},
  allowDefaultSearch: false
};
export default ListingSearchAutocomplete;